import {
  motion
} from "framer-motion";

function Reveal({

  children,

  delay = 0,

  duration = 0.8,

  y = 60,

  blur = 8,

  once = true,

  className = ""

}) {

  return (

    <motion.div

      initial={{
        opacity: 0,
        y: y,
        filter: `blur(${blur}px)`
      }}

      whileInView={{
        opacity: 1,
        y: 0,
        filter: "blur(0px)"
      }}

      viewport={{
        once,
        amount: 0.15
      }}

      transition={{
        duration,
        delay,
        ease: [0.22, 1, 0.36, 1]
      }}

      className={className}
    >

      {children}

    </motion.div>

  );

}

export default Reveal;